import { DataGrid, GridRenderCellParams, esES, GridToolbar, GridColDef} from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {addToActiveList, addToInactiveList} from '@/redux/states'
import { AppStore } from '@/redux/store';
import { Box, Button, Checkbox, Chip, IconButton, Tooltip, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import {alertConfirm, alertDelete} from '@/utilities/alertsSwal';
import { ModalStars, ModalTableDetail } from '@/modals';
import instituteService from '@/api/institute.service';
// import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import { InstituteProps, LocationProps } from '@/types';
import './Table.scss'
import { tokens } from '@/utilities';
import { Header } from '@/views';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ModalUpdateSubscriptionLevel from '../ModalUpdateSubscriptionLevel';

// type AppDispatch = ThunkDispatch<AppStore, undefined, AnyAction>

export interface TableProps {
    active: boolean
}

export function Table(props:TableProps){

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const location = useLocation();
    const navigate = useNavigate();

    const [isOn, setIsOn] = useState(props.active);
    const [paginationModel, setPaginationModel]= useState({
        pageSize: 10,
        page: 0,
    })

    const dispatch= useDispatch()

    const activeList = useSelector((store: AppStore)=> store.activeList)
    const inactiveList = useSelector((store: AppStore)=> store.inActiveList)
    
    // const [selectedInstitute, setSelectedInstitute] = useState<InstituteProps[]>([]);

    const [selectedInstituteData, setSelectedInstituteData] = useState<InstituteProps | null> (null);
    const [selectedInstituteForSubscription, setSelectedInstituteForSubscription] = useState<InstituteProps | null>(null);
    const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState<boolean>(false);

    const handleOpenSubscriptionModal = (institute: InstituteProps) => {
        setSelectedInstituteForSubscription(institute);
        setIsSubscriptionModalOpen(true);
    };

    const handleSubscriptionUpdated = (updatedInstitute: InstituteProps) => {
        if (selectedInstituteData && (selectedInstituteData.id === updatedInstitute.id || selectedInstituteData.code === updatedInstitute.code)) {
            setSelectedInstituteData(updatedInstitute);
        }
    };

	const findInstitute = (institute: InstituteProps)=> !!inactiveList.find (ies=> ies.id === institute.id)
    
	//   !! use to convert the result in a boolean

	// const filterInstitute = (institute: InstituteProps)=> inactiveList.filter(ies=> ies.id !== institute.id)
    
   
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

   
    const getInstituteData= (id:string)=> {
        if(props.active === true){
        return  activeList.find((item)=> item.id == id) || null

        } else if(props.active === false){

            return inactiveList.find((item)=> item.id == id) || null
        }
        return null
    }
    
    const handleDetailClick = (id: string) => {
        const selectedInstitute = getInstituteData(id)
          setSelectedInstituteData(selectedInstitute);
          setIsModalOpen(true);
        //   console.log("EL ID SELECCIONADO ES", id)
    };

    const handleDelete = async (id: string)=>{
        try {
            const responseAlertDelete = await alertDelete()
            if (responseAlertDelete ){
                instituteService.delete(id)
            }
        } catch (error) {
            console.error(error)
        }
    }
    // check logic in hanldeChange

    const handleChange = (institute: InstituteProps)=>{
        // const filteredInstitute = findInstitute(institute)
        // ? filterInstitute(institute)
        // :[...selectedInstitute, institute];
        // // dispatch(addToInactiveList(filteredInstitute))
        // setSelectedInstitute(filteredInstitute)
        console.log("checked", institute)
    }

    const handleClickSwitch = async (id: string) => {
        const responseAlert = await alertConfirm()
        if (responseAlert ){
             rows.map(institute =>{
                if(institute.id === id){
                    return {...institute, active: !institute.active}
                }
                return institute
            })
            setIsOn(prevState => !prevState);
        }
        // Lógica adicional según tus preferencias, utilizando rowId para identificar la fila
        if (!isOn) {
          // Realizar acciones cuando el switch cambia a "on"
          
        } else {
          // Realizar acciones cuando el switch cambia a "off"
       
        }
      };
      
    const columns = [
        props.active === false && {
            field: 'actions',
            type:'actions',
            sortable: false,
            headerName: '',
            flex: 1,
            minWidth: 50,
            renderCell: (params: GridRenderCellParams) => <>{
                <Checkbox 
                    size='small'
                    // checked={params.row.id}
                    checked={findInstitute(params.row.id)} 
                    onChange={()=>handleChange(params.row.id)}
                />
            }</>
        },
        {
            key: 'name',
            field: 'name',
            headerName: 'Nombre',
            flex: 1,
            minWidth: 250,
            cellClassName: "name-column--cell",
            renderCell: (params: GridRenderCellParams)=><>{params.value}</>/*what we want to show in row, we are going to associate the object (in this case IES -comes from data-) and decide how to show. GridRedenderCellParams are the grid´s params  */

        },
        {
            key: 'headquarters',
            field: 'headquarters',
            headerName: 'Sede',
            flex: 1,
            minWidth: 150,
            renderCell: (params: GridRenderCellParams)=><>
            {params.row.headquarters.map((hq:LocationProps, index:number) => (
            <div key={index}>{hq.title}</div>
      ))    }
            </>
        },
        {
            key: 'character',
            field: 'character',
            headerName: 'Carácter',
            flex: 1,
            minWidth: 100,
            renderCell: (params: GridRenderCellParams)=><>{params.value}</>
        },
        {
            key:'type',
            field: 'type',
            headerName: 'Tipo',
            flex: 1,
            minWidth: 150,
            renderCell: (params: GridRenderCellParams)=><>{params.value}</>
        },
        {
            key:'email',
            field: 'email',
            headerName: 'Email Admin',
            flex: 1,
            minWidth: 200,
            renderCell: (params: GridRenderCellParams)=><>{params.value}</>
        },
        {
            key: 'subscriptionLevel',
            field: 'subscriptionLevel',
            headerName: 'Nivel Suscripción',
            flex: 1,
            minWidth: 170,
            align: 'center',
            headerAlign: 'center',
            sortable: true,
            renderCell: (params: GridRenderCellParams) => {
                const level = typeof params.value === 'number' ? params.value : 0;
                const isPremium = level > 0;
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.8 }}>
                        <Tooltip title={`Nivel ${level} (0 al 10) - Clic para actualizar`}>
                            <Chip
                                icon={
                                    <WorkspacePremiumIcon
                                        sx={{
                                            fontSize: '18px !important',
                                            color: isPremium ? '#FFD700' : 'inherit',
                                        }}
                                    />
                                }
                                label={`Nivel ${level}`}
                                size="small"
                                onClick={() => handleOpenSubscriptionModal(params.row)}
                                sx={{
                                    cursor: 'pointer',
                                    fontWeight: 600,
                                    fontSize: '0.78rem',
                                    backgroundColor: isPremium
                                        ? (theme.palette.mode === 'dark' ? 'rgba(63, 81, 181, 0.3)' : '#E8EAF6')
                                        : (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#F1F5F9'),
                                    borderColor: isPremium ? '#3F51B5' : colors.grey[400],
                                    '&:hover': {
                                        backgroundColor: isPremium
                                            ? (theme.palette.mode === 'dark' ? 'rgba(63, 81, 181, 0.5)' : '#D1D9F5')
                                            : (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : '#E2E8F0'),
                                    },
                                }}
                                variant="outlined"
                            />
                        </Tooltip>
                        <Tooltip title="Actualizar nivel de suscripción (0 al 10)">
                            <IconButton
                                size="small"
                                aria-label={`Actualizar nivel de suscripción de ${params.row.name}`}
                                onClick={() => handleOpenSubscriptionModal(params.row)}
                                sx={{
                                    color: colors.blueAccent[300],
                                    minWidth: 32,
                                    minHeight: 32,
                                    '&:hover': {
                                        color: colors.blueAccent[100],
                                        backgroundColor: 'rgba(0, 127, 192, 0.1)',
                                    },
                                }}
                            >
                                <EditIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                );
            },
        },
        {
            key: 'detail',
            field: 'detail',
            headerName: 'Detalle',
            flex: 1,
            minWidth: 100,
            type:"actions",
            renderCell: (params: GridRenderCellParams)=>(
                <Box className='icon-table'  >
                    <Box sx={{
                        backgroundColor:colors.blueAccent[700],
                        borderRadius:"5px",
                        border:"none"
                    }} 
                    onClick={()=>handleDetailClick(params.row.id)}
                   >
                      
                    <Button variant="outlined" sx={{border:"none"}} >
                        <RemoveRedEyeIcon/>
                    </Button>
                    </Box>
                </Box>
            )
        },
        {
            key: 'inactive',
            field: 'Inactive',
            headerName: 'Inactivar',
            flex: 1,
            minWidth: 100,
            renderCell: (params: GridRenderCellParams)=>(
            <>
                <ToggleButtonGroup
                    value={params.row.active}
                    exclusive
                    onChange={()=>{
                        const updatedInstitutes = rows.map(institute =>{
                            if(institute.id === params.row.id){
                                return {...institute, active: !institute.active}
                            }
                            return institute
                        })
                        addToInactiveList(updatedInstitutes)
                    }}
                >
                    
                    <ToggleButton  value={params.row.active}>
                      <label className={`switch-button ${isOn ? 'on' : 'off'}`} onClick={()=>handleClickSwitch}>
                        <input type="checkbox" checked={isOn} readOnly />
                        <span className="slider"></span>
                        </label>
                    </ToggleButton>
               
                </ToggleButtonGroup>
            </>)
        },
        props.active === false &&
        {
            key: 'delete',
            field: 'delete',
            headerName: 'Eliminar',
            flex: 1,
            renderCell: (params: GridRenderCellParams)=>(
                <div className='icon-table'>
                    <Box onClick={() => handleDelete(params.row.id)}>
                    <DeleteForeverIcon className='icon-delete'/>
                    </Box>
                </div>
            )
        },
    ].filter(Boolean) as GridColDef<InstituteProps>[]

    useEffect(()=>{
        const fetchData = async ()=>{
            try {
                const institutes = await instituteService.getAll(props.active)
                if(props.active === true){
                    dispatch(addToActiveList(institutes))
                }else{
                    dispatch(addToInactiveList(institutes))
                }
                // dispatch(addInstitutes(institutes))
            } catch (error) {
              console.error(error)  
            }
        }
        fetchData()
    },[dispatch, props.active])

    useEffect(() => {
        setIsOn(props.active);
      }, [props.active]);

    useEffect(() => {
        const targetCode = location.state?.selectedInstituteCode;
        if (!targetCode) return;

        const findAndOpenInstitute = async () => {
            let target = [...activeList, ...inactiveList].find(
                (item) => item.code === targetCode || item.id === targetCode
            );

            if (!target) {
                try {
                    const byId = await instituteService.getById(targetCode);
                    if (byId) {
                        target = byId;
                    } else {
                        const byCode = await instituteService.getByCode(targetCode);
                        if (byCode && byCode.length > 0) {
                            target = byCode[0];
                        }
                    }
                } catch (error) {
                    console.error("Error fetching institute for detail view:", error);
                }
            }

            if (target) {
                setSelectedInstituteData(target);
                setIsModalOpen(true);
                navigate(location.pathname, { replace: true, state: {} });
            }
        };

        findAndOpenInstitute();
    }, [location.state, activeList, inactiveList, navigate, location.pathname]);
      
    const rows = props.active ?activeList: inactiveList
    
  return (
    <Box sx={{
        padding:"0 30px"
    }}>
        <Header title='Tabla instituciones' subtitle='Maneja tus instituciones'/>
        <Box sx={{
            paddingBottom:"80px",
            "& .MuiDataGrid-root":{
                border:"none",
            },
            "& .MuiDataGrid-cell":{
                borderBottom:"none"
            },
            "& .name-column--cell":{
                color: colors.blueAccent[500]
            },
            "& .MuiDataGrid-columnHeaders":{
                backgroundColor: "#007FC0",
                borderBottom: "none",
                color:"#fcfcfc"
            },
            "& .MuiDataGrid-virtualScroller":{
                backgroundColor: colors.primary[400]
            },
            "& .MuiDataGrid-footerContainer":{
                borderTop: "none",
                backgroundColor: "#007FC0"
            },
            "& .MuiDataGrid-toolbarContainer .MuiButton-text":{
                color: `${colors.grey[100]} !important`
            }
        }}>
            <DataGrid
                rows={rows}
                columns={columns}
                disableColumnSelector
                disableRowSelectionOnClick
                autoHeight
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                getRowId={(row:any)=> row.id}
                pageSizeOptions={[10,15,20]}
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                slots={{toolbar:GridToolbar}}
                sx={{
                    height:'100%',
                    '& .MuiDataGrid-cell:hover': {
                        color: colors.blueAccent[300],
                    },
                }}
                
                />
        </Box>
        { selectedInstituteData && ( // Mostrar el modal si está seleccionado y hay datos seleccionados
            <ModalTableDetail
                selectedInstituteData={selectedInstituteData}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen} 
            />
        )}
        { selectedInstituteForSubscription && (
            <ModalUpdateSubscriptionLevel
                open={isSubscriptionModalOpen}
                onClose={() => {
                    setIsSubscriptionModalOpen(false);
                    setSelectedInstituteForSubscription(null);
                }}
                institute={selectedInstituteForSubscription}
                onUpdated={handleSubscriptionUpdated}
            />
        )}
    </Box>
  )
}

